import { NgModule, InjectionToken } from "@angular/core";
import type { ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ThemeService } from "./theme.service";
import { ThemeDirective } from "./theme.directive";
import { THEMES, ACTIVE_THEME, ThemeOptions } from "./symbols";

/** Provides the theme directive and service; use forRoot() to register themes. */
@NgModule({
  imports: [CommonModule, ThemeDirective],
  providers: [ThemeService],
  exports: [ThemeDirective],
})
export class ThemeModule {
  static forRoot(options: ThemeOptions): ModuleWithProviders<NgModule> {
    return {
      ngModule: ThemeModule,
      providers: [
        {
          provide: THEMES,
          useValue: options.themes,
        },
        {
          provide: ACTIVE_THEME,
          useValue: options.active,
        },
      ],
    };
  }
}
